export default "__VITE_ASSET__21be0556__"